﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IResizeScope extends ng.IScope {
    handles: string;
    containment: string;
    minWidth: string;
    maxWidth: string;
    minHeight: string;
    maxHeight: string;
    resizeDisabled: boolean;
    onStop: () => void;
}

@NgComponent({
    token: Token.KbResize,
    dependencies: [
    ]
})
export class KbResize extends Directive {
    constructor() {
        super();

        this.restrict = "E";
        this.replace = true;
        this.transclude = true;
        this.scope = {
            handles: "@", // n, e, s, w, ne, se, sw, nw
            containment: "@", // parent or a selector for the element that constrains the size
            minWidth: "@",
            maxWidth: "@",
            minHeight: "@",
            maxHeight: "@",
            onStop: "&",
            resizeDisabled: "=?"
        };
        this.template = Dirs.component("kb-resize");

        this.link = (scope: IResizeScope, elem: ng.IAugmentedJQuery, atts: ng.IAttributes) => {

            if (scope.minWidth) elem.css("min-width", scope.minWidth);
            if (scope.maxWidth) elem.css("max-width", scope.maxWidth);
            if (scope.minHeight) elem.css("min-height", scope.minHeight);
            if (scope.maxHeight) elem.css("max-height", scope.maxHeight);

            let exists = false;
            let createResizable = () => {
                elem.resizable({
                    handles: scope.handles,
                    containment: scope.containment || "parent",
                    stop: () => {
                        if (scope.onStop) scope.onStop();
                    }
                } as any);
                exists = true;
            };
            let destroyResizable = () => {
                if (exists) elem.resizable("destroy");
                exists = false;                
            };

            // resizable doesn't handle flexbox well so we override the resize method for our own custom logic
            let resize = (event, ui) => {
                ui.position.left = ui.originalPosition.left;
            };

            elem.on("resize", resize);

            scope.$watch("handles", () => {
                if (exists) elem.resizable("option", "handles", scope.handles);
            });

            scope.$watch("disabled", () => {
                if (scope.resizeDisabled) {
                    destroyResizable();
                } else {
                    createResizable();
                }
            });

            scope.$on("$destroy", () => {
                elem.off("resize");
                destroyResizable();
            });
        };

    }
}
